export const GRADES = [
  { value: "3rd", label: "3rd Year" },
  { value: "4th", label: "4th Year" },
  { value: "5th", label: "5th Year" },
  { value: "6th", label: "6th Year" },
]
